import { render, staticRenderFns } from "./PunkteSammelBox.vue?vue&type=template&id=652e5af4&scoped=true"
import script from "./PunkteSammelBox.vue?vue&type=script&lang=js"
export * from "./PunkteSammelBox.vue?vue&type=script&lang=js"
import style0 from "./PunkteSammelBox.vue?vue&type=style&index=0&id=652e5af4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e5af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652e5af4')) {
      api.createRecord('652e5af4', component.options)
    } else {
      api.reload('652e5af4', component.options)
    }
    module.hot.accept("./PunkteSammelBox.vue?vue&type=template&id=652e5af4&scoped=true", function () {
      api.rerender('652e5af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/PunkteSammelBox.vue"
export default component.exports